import {
  REGION_COOKIE,
  type ConsentRegion,
} from "../classify-geo/classifyGeo"

export function resolveRegion(): ConsentRegion {
  const match = document.cookie
    .split("; ")
    .find(row => row.startsWith(`${REGION_COOKIE}=`))
    ?.split("=")[1]

  return match === "ungated" ? "ungated" : "gated"
}
